import React from "react";
import { useSelector } from "react-redux";

import GroupSelectBox from "components/GroupMultipleSelect";
import CollapsibleTable from "../table/CollapsibleTable";

import { useEffect, useRef, useLayoutEffect } from "react";
import { Button, Box, Grid, TextField, Paper } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { setRows } from "redux/suspiciousRow";
import { useDispatch } from "react-redux";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { usePromiseTracker } from "react-promise-tracker";
import { Bars } from "react-loader-spinner";
import Backdrop from "@mui/material/Backdrop";
import qs from "qs";
import ReportTable from "components/table/ReportTable";
import ToExcel from "icons/Toexcel";

import {
  disable,
  reset,
  setAllSelected,
  setItems,
  setAllItems,
  setPerStore,
} from "redux/dropDownStores";
import {
  setItemsList,
  resetItemsList,
  reloadItemsList,
  addMultipleSelect,
} from "redux/dropDownStores";

function SuspiciousTable() {
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [submitEndDate, setSubmitEndDate] = React.useState(new Date());
  const [submitStartDate, setSubmitStartDate] = React.useState(new Date());

  const [submitStatus, setSubmitStatus] = React.useState([]);
  const [toExcelDisabled, setToExcelDisabled] = React.useState(true);
  const [submitDisable, setSubmitDisable] = React.useState(true);
  const [allStores, setAllStores] = React.useState(false);
  const [rows, setRows] = React.useState({
    detailed: [],
    total: {
      total_sales: 0,
      total_budget: 0,
      total_percent: 0,
      total_transactions: 0,
      total_average: 0,
    },
  });
  const allMultipleSelects = useSelector((state) => state.stores);

  const districtsComponent =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "reports.districts",
    ) == -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "reports.districts",
        );

  const selectedStatus = useSelector((state) => state.selectBox.selectedValue);
  const dispatcher = useDispatch();
  const updateRow = useSelector((state) => state.suspiciousRow);

  const [options, setOptions] = React.useState({});

  useEffect(() => {
    //dispatcher(disable({componentName:'reports.districts',disabled: true}))
    axios
      .get("http://192.168.14.53:8000/api/storesDistricts/by_district/", {})
      .then((res) => setOptions(res.data));
  }, []);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  //console.log(districtsComponent)

  const fetchData = async (startDate, endDate, items, allStores) => {
    try {
      const response = await axios.get(
        "http://192.168.14.53:8000/api/budgetReport/some_store_sales_budget/",
        {
          params: {
            startDate: startDate.toISOString().split("T")[0],
            endDate: endDate.toISOString().split("T")[0],
            stores: items,
            allStores: allStores,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" }); // Serialize array as repeated params
          },
        },
      );

      console.log(typeof response.data);
      setToExcelDisabled(false);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const importExcel = async (startDate, endDate, items, allStores) => {
    try {
      const response = await axios.get(
        "http://192.168.14.53:8000/api/budgetReport/some_store_sales_budget_export_excel/",
        {
          params: {
            startDate: startDate.toISOString().split("T")[0],
            endDate: endDate.toISOString().split("T")[0],
            stores: items,
            allStores: allStores,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" }); // Serialize array as repeated params
          },
          responseType: "blob",
        },
      );
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetchData(
      startDate,
      endDate,
      allMultipleSelects[districtsComponent].items,
      allMultipleSelects[districtsComponent].allItems,
    ).then((data) => {
      setRows(data);
    });
  };

  const downloadExcel = async (event) => {
    event.preventDefault();
    try {
      const response = await importExcel(
        startDate,
        endDate,
        allMultipleSelects[districtsComponent].items,
        allMultipleSelects[districtsComponent].allItems,
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.xlsx"); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const defaultStatus = [];

  return (
    <>
      <Paper
        elevation={5}
        style={{ padding: "6px", margin: "15px 25px 10px 20px" }}
      >
        <form noValidate onSubmit={handleSubmit}>
          <Box pt={5} pb={5} pl={2}>
            <Grid container spacing={7}>
              <Grid item md={2} xs={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    variant="inline"
                    inputVariant="outlined"
                    label="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                  ></DatePicker>
                </LocalizationProvider>
              </Grid>
              <Grid item md={2} xs={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    variant="inline"
                    inputVariant="outlined"
                    label="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                  ></DatePicker>
                </LocalizationProvider>
              </Grid>
              <Grid item md={4} xs={4}>
                <GroupSelectBox
                  options={options}
                  defaultStatus={defaultStatus}
                  title={"Districts"}
                />
              </Grid>

              <Grid item style={{ marginTop: 22, paddingRight: 14 }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={allMultipleSelects[districtsComponent].disabled}
                >
                  Submit
                </Button>
              </Grid>
              <Grid item style={{ marginTop: 22 }}>
                <Button
                  variant="contained"
                  startIcon={<ToExcel />}
                  disabled={toExcelDisabled}
                  onClick={(event) => downloadExcel(event, false)}
                ></Button>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Paper>
      {rows.detailed.length > 0 && (
        <Paper
          elevation={3}
          style={{ padding: "6px", margin: "15px 25px 10px 20px" }}
        >
          <Grid
            container
            justifyContent="space-between"
            spacing={4}
            sx={{ px: 3, py: 4 }}
          >
            <Grid item md={2} xs={12}>
              <TextField
                fullWidth
                label="Total Sales"
                value={rows.total.total_sales?.toLocaleString() || ""}
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined" // or "filled" or "standard"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <TextField
                fullWidth
                label="Total Budget"
                value={rows.total.total_budget?.toLocaleString() || ""}
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined" // or "filled" or "standard"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <TextField
                fullWidth
                label="Total %"
                value={rows.total.total_percent}
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined" // or "filled" or "standard"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <TextField
                fullWidth
                label="Total Transactions"
                value={rows.total.total_transactions?.toLocaleString() || ""}
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined" // or "filled" or "standard"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <TextField
                fullWidth
                label="Total Average"
                value={rows.total.total_average}
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined" // or "filled" or "standard"
              />
            </Grid>
          </Grid>

          <Grid item md={12} xs={12} sx={{ marginTop: "40px" }}>
            <ReportTable rows={rows.detailed} />
          </Grid>
        </Paper>
      )}
    </>
  );
}

export default SuspiciousTable;
